export const validations = {
  'Please, inform a valid email':
    'Por favor, ingrese un correo electrónico válido',
  'Please, inform a valid whatsapp number':
    'Por favor, ingrese un número válido de WhatsApp',
  'Please, inform both the name and surname':
    'Por favor, ingrese su nombre y apellido',
  'This field is required': 'Este campo es obligatorio',
};
